<script setup>
import { ref } from "vue";
import CopyActionButton from "./CopyActionButton.vue";

const instructionsCopied = ref(false);

const copyInstructions = () => {
    const lines = [
        `Email: ${props.zelleEmail}`,
        props.zelleReference ? `Amount: $${props.currencyFormat(props.totalAmount)}` : null,
        props.zelleReference ? `Memo: ${props.zelleReference}` : null,
    ].filter(Boolean).join("\n");
    navigator.clipboard.writeText(lines);
    instructionsCopied.value = true;
    setTimeout(() => (instructionsCopied.value = false), 2000);
};

const props = defineProps({
    zelleEmail: { type: String, default: "" },
    invoiceEmail: { type: String, default: "" },
    zelleReference: { type: String, default: "" },
    totalAmount: { type: [String, Number], default: "0" },
    selectedInvoicesCount: { type: Number, default: 0 },
    copiedKey: { type: String, default: "" },
    copyToClipboard: { type: Function, required: true },
    currencyFormat: { type: Function, required: true },
    layout: { type: String, default: "full" },
});

const contentGridClass = props.layout === "sidebar" ? "grid grid-cols-1 gap-2" : "grid grid-cols-1 md:grid-cols-2 gap-4";
</script>

<template>
    <div class="space-y-2">
        <div
            class="rounded-lg border border-theme-border border-opacity-40 bg-white px-3 py-2.5 flex items-center justify-between gap-3">
            <div>
                <p class="text-tiny uppercase tracking-wide text-theme-body-light font-semibold">Send Zelle To</p>
                <p class="text-theme-secondary text-sm font-normal mt-0.5 break-all">{{ props.zelleEmail }}</p>
            </div>
            <CopyActionButton :value="props.zelleEmail" copy-key="zelleEmailR" :copied-key="props.copiedKey"
                :copy-to-clipboard="props.copyToClipboard" />
        </div>

        <div :class="contentGridClass">
            <div
                class="rounded-lg border border-theme-border border-opacity-40 bg-white px-3 py-2.5 flex items-start justify-between gap-3"
                :class="{ 'opacity-50': !props.zelleReference }">
                <div>
                    <p class="text-tiny uppercase tracking-wide text-theme-body-light font-semibold">Amount</p>
                    <p class="text-theme-secondary text-sm font-normal mt-0.5 amount-number">{{ props.zelleReference ?
                        `$${props.currencyFormat(props.totalAmount)}` : 'Select invoices above' }}</p>
                </div>
                <CopyActionButton v-if="props.zelleReference" :value="`$${props.currencyFormat(props.totalAmount)}`"
                    copy-key="zelleAmtR" :copied-key="props.copiedKey" :copy-to-clipboard="props.copyToClipboard" />
            </div>

            <div
                class="rounded-lg border border-theme-border border-opacity-40 bg-white px-3 py-2.5 flex items-start justify-between gap-3"
                :class="{ 'opacity-50': !props.zelleReference }">
                <div>
                    <p class="text-tiny uppercase tracking-wide text-theme-body-light font-semibold">Memo</p>
                    <p class="text-theme-secondary text-sm font-normal mt-0.5 tracking-wider">{{
                        props.zelleReference || 'Select invoices above' }}</p>
                </div>
                <CopyActionButton v-if="props.zelleReference" :value="props.zelleReference" copy-key="zelleMemoR"
                    :copied-key="props.copiedKey" :copy-to-clipboard="props.copyToClipboard" />
            </div>
        </div>

        <!-- <div
            class="rounded-lg border border-theme-border border-opacity-40 bg-theme-bg-shade bg-opacity-10 px-3 py-2.5 text-xs text-theme-body leading-relaxed">
            <span class="font-semibold text-theme-secondary">Already sent it?</span>
            Tap below to ping our AR team — we'll match it to your order.
        </div> -->

        <div class="flex items-center gap-2 flex-wrap"
            :class="props.layout === 'sidebar' ? 'pt-3 mt-1 border-t border-theme-border border-opacity-40' : 'pt-0.5'">
            <!-- <button type="button"
                class="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg bg-theme-secondary text-white text-xs font-semibold hover:bg-opacity-95 transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M20 6L9 17l-5-5" />
                </svg>
                I sent the Zelle
            </button> -->
            <button type="button" @click="copyInstructions"
                class="text-theme-secondary inline-flex items-center gap-1.5 px-3 py-2 rounded-lg border border-theme-border border-opacity-60 bg-white text-xs font-semibold hover:bg-theme-bg-shade hover:bg-opacity-20 transition-colors"
            >
                <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
                    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                </svg>
                {{ instructionsCopied ? 'Copied!' : 'Copy instructions' }}
            </button>
        </div>
    </div>
</template>
